module.exports = __webpack_public_path__ + "img/pic-noData.6a4ea661.png";